.container {
    display: grid;
    grid-template-columns: 1fr 1fr 3em;
    justify-content: space-between;
    gap: 2em;
    align-items: center;
    padding: 16px 24px;
    text-align: left;
}
